import { Box, Tooltip } from '@wix/design-system';
import { StatusAlertSmall, StatusComplete, StatusCompleteSparkleSmall, StatusWarningSmall } from '@wix/wix-ui-icons-common';
import React from 'react';
import { dataHooks } from '../../utils/datahooks';
import { usePreviousState } from '../../utils/use-previous-state';
import { ElementStatus } from './types';
export const PrefixStatusIcon = _ref => {
  let {
    status,
    dataHook,
    prefixStatusIconTooltip,
    onShowTooltip
  } = _ref;
  const prevStatus = usePreviousState(status);
  switch (status) {
    case ElementStatus.GeneratedAll:
    case ElementStatus.Generated:
      return /*#__PURE__*/React.createElement(Box, {
        color: "G10",
        dataHook: dataHooks.ruleElementGeneratedStatusIcon(dataHook)
      }, /*#__PURE__*/React.createElement(StatusCompleteSparkleSmall, {
        size: "18px"
      }));
    case ElementStatus.Passed:
      return /*#__PURE__*/React.createElement(Box, {
        color: "G10",
        dataHook: dataHooks.ruleElementGreenStatusIcon(dataHook)
      }, /*#__PURE__*/React.createElement(StatusComplete, {
        size: "18px"
      }));
    case ElementStatus.Warning:
      return /*#__PURE__*/React.createElement(Box, {
        color: "Y10",
        dataHook: dataHooks.ruleElementYellowStatusIcon(dataHook)
      }, /*#__PURE__*/React.createElement(Tooltip, {
        content: /*#__PURE__*/React.createElement(Box, null, prefixStatusIconTooltip),
        placement: "top",
        size: "small",
        onShow: onShowTooltip
      }, /*#__PURE__*/React.createElement(StatusWarningSmall, {
        size: "18px"
      })));
    case ElementStatus.Loading:
      return /*#__PURE__*/React.createElement(PrefixStatusIcon, {
        dataHook: dataHook,
        status: prevStatus
      });
    case ElementStatus.Failed:
    default:
      return /*#__PURE__*/React.createElement(Box, {
        color: "R10",
        dataHook: dataHooks.ruleElementRedStatusIcon(dataHook)
      }, /*#__PURE__*/React.createElement(StatusAlertSmall, {
        size: "18px"
      }));
  }
};
//# sourceMappingURL=prefix-status-icon.js.map